import { GpfListPageHeader, GpfListTable } from './components';
import { useUser } from '@hooks/useUser';

function GpfList() {
  const { user } = useUser();
  const { employeeMasterId } = user;

  return (
    <div className="d-grid gap-10 p-10">
      <GpfListPageHeader id={employeeMasterId} />
      <GpfListTable />
    </div>
  );
}
export default GpfList;
